import React from "react";
import "../styles/About.css";
  import SEO from "../components/SEO.js";
const About = () => {
  return ( 
<section id="about" className="about-section">

  <SEO
    title="About Square Feet Marble | Imported & Italian Marble Specialists Since 1969"
    description="Square Feet Marble is a legacy imported marble company based in Kishangarh, Rajasthan. Discover our history, values, and expertise in premium Italian and imported marble since 1969."
    canonical="https://squarefeetmarble.com/about"
    ogImage="https://squarefeetmarble.com/showroom-imported-marble-kishangarh.webp"
  />

  <div className="about-content">

    {/* H1 – REQUIRED */}
    <h1>About Square Feet Marble</h1>

    <p className="tagline">
      Imported & Italian Marble Specialists • Kishangarh, Rajasthan
    </p>

    <p>
      <strong>Square Feet Marble</strong> is a family-driven marble enterprise based in 
      <strong> Kishangarh, Rajasthan</strong>— which is widely recognised as the Marble Capital of India. 
      Established in <strong>1969</strong>, the company has grown into a trusted name in 
      <strong> imported marble, Italian marble, and premium natural stones</strong>, serving 
      clients across India.
    </p>

    <p>
      Founded by the <strong>Bhandari family</strong>, Square Feet Marble represents over 
      <strong> five decades of hands-on experience</strong> in sourcing, processing, and supplying 
      high-quality marble for architectural and interior applications. Our legacy is built on 
      long-term relationships, ethical sourcing, and a deep understanding of natural stone.
    </p>

    <h2>Our Presence in Kishangarh</h2>

    <p>
      Operating from our <strong>showroom and stockyard in Kishangarh</strong>, we maintain a 
      carefully curated inventory of marble slabs imported from renowned quarries in 
      <strong> Portugal, Italy, Turkey, Greece, Spain, Vietnam, and Brazil</strong>. Clients can personally 
      inspect slabs, evaluate finishes, and select marble under natural lighting conditions.
    </p>

    <h2>What We Do</h2>

    <p>
      Square Feet Marble specialises in supplying premium marble for 
      <strong> luxury residences, villas, hotels, commercial spaces, and bespoke projects</strong>. 
      Our team supports clients with slab selection, quantity estimation, book-matching layouts, 
      and technical guidance to ensure seamless execution.
    </p>

    <h2>Trusted by Professionals Across India</h2>

    <p>
      Over the years, Square Feet Marble has supplied stone for thousands of projects across 
      India, working closely with <strong>architects, interior designers, builders, developers, 
      and private homeowners</strong>. Our approach focuses on reliability, consistency in quality, 
      and transparent business practices.
    </p>

    <h2>Our Values</h2>

    <ul className="key-list">
      <li>Commitment to premium-grade marble only</li>
      <li>Ethical sourcing from established global quarries</li>
      <li>Transparent pricing and professional guidance</li>
      <li>Long-term relationships over short-term sales</li>
      <li>Consistent quality control at every stage</li>
    </ul>

    <h2>Looking Ahead</h2>

    <p>
      While our roots remain firmly grounded in Kishangarh, Square Feet Marble continues to 
      evolve with modern design needs and international stone trends. Our focus remains on 
      delivering <strong>timeless marble solutions</strong> that combine natural beauty, durability, 
      and refined aesthetics.
    </p>

    <p>
      <strong>
        Square Feet Marble — a legacy of trust, craftsmanship, and premium imported marble since 1969.
      </strong>
    </p>

  </div>
</section>

  );
};

export default About;
